module.exports = {"371503001":"振兴街道","371503002":"信发街道","371503003":"温陈街道","371503101":"乐平铺镇","371503102":"冯官屯镇","371503103":"菜屯镇","371503104":"博平镇","371503105":"杜郎口镇","371503106":"韩屯镇","371503107":"胡屯镇","371503108":"肖家庄镇","371503109":"贾寨镇","371503110":"洪官屯镇","371503208":"杨官屯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371503.json
// module id = 1604
// module chunks = 0